const APP = {
  COMMERCIAL_EMAIL: 'comercial@promobit.com.br',
  CTX_OPTIONAL_PROPS: '__app-ctx-optional-props',
  DEFAULT_LOCALE: 'pt_BR',
  FAVICON: '/dist/favicon.ico',
  LOCAL_IMAGE_PATH: '/dist/images',
  NAME: 'Promobit',
  REMOTE_IMAGE_PATH: 'https://i.promobit.com.br',
  LEGAL_NAME: 'Promobit Servicos de Tecnologia Digital Ltda',
  URL: 'https://www.promobit.com.br',
  SHORTENED_URL: 'promobit.com.br',
  ADDRESS: {
    COMPLETE_ADDRESS:
      'R. José Versolato, 111 - B, sala 3014, São Bernardo do Campo - SP',
    POSTAL_CODE: '09750-730',
    STREET: 'R. José Versolato 111',
    CITY: 'São Bernardo do Campo',
    ACRONYM_STATE: 'SP',
    ACRONYM_COUNTRY: 'BR',
  },
};

export default APP;
